import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NodeCredentialsComponent } from './node-credentials/node-credentials.component';
import {ActionBarModule} from '../../../components/action-bar/action-bar.module';
import {ArmTableModule} from '../../../components/arm-table/arm-table.module';
import {CredentialsTableModule} from './components/credentials-table.module';
import { RouterCredentialsComponent } from './router-credentials/router-credentials.component';
import {FormsModule} from '@angular/forms';
import {MaterialModule} from '../../../material.module';



@NgModule({
  declarations: [NodeCredentialsComponent, RouterCredentialsComponent],
  imports: [
    CommonModule,
    ActionBarModule,
    ArmTableModule,
    CredentialsTableModule,
    FormsModule,
    MaterialModule
  ]
})
export class CredentialsModule { }
